import type { SVGProps } from 'react';

const SvgContactFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M8.5 19C6.567 19 5 17.433 5 15.5V10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.134 19 10V11.5333'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
    />
    <path
      d='M19 9.14286C19 9.06396 19.064 9 19.1429 9V9C20.7208 9 22 10.2792 22 11.8571V12.1429C22 13.7208 20.7208 15 19.1429 15V15C19.064 15 19 14.936 19 14.8571V9.14286Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <path
      d='M5 9.14286C5 9.06396 4.93604 9 4.85714 9V9C3.27919 9 2 10.2792 2 11.8571V12.1429C2 13.7208 3.27919 15 4.85714 15V15C4.93604 15 5 14.936 5 14.8571V9.14286Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <rect x={8.5} y={17} width={7.5} height={4} rx={2} fill='currentColor' stroke='currentColor' strokeWidth={1.5} />
  </svg>
);
export default SvgContactFilled;
